// The admin panel's map speed test (src/admin/MapPerfTab.js) opens the views in a frame with `?perf=1`: that
// page sends no analytics, opens on an admin hostname too (the admin panel's own origin), and each view hands
// its Leaflet map to the test (window.__perfMap). Read once at load, as the views may rewrite the URL.
const PERF_RUN = (() => {
    try {
        return new URLSearchParams(window.location.search).has('perf');
    } catch (error) {
        return false;
    }
})();

export const isPerfRun = () => PERF_RUN;

// The requests in flight, so the test can tell when the view has stopped loading (a request still loading has no
// resource-timing entry yet; listvy's map homes come in batches that take seconds each).
if (PERF_RUN && typeof window.fetch === 'function') {
    const net = { inFlight: 0, last: performance.now() };
    window.__perfNet = net;
    const fetchFn = window.fetch.bind(window);
    window.fetch = (...args) => {
        net.inFlight += 1;
        net.last = performance.now();
        return fetchFn(...args).finally(() => {
            net.inFlight -= 1;
            net.last = performance.now();
        });
    };
}

// For a view's effect: useEffect(() => exposeMapForPerf(map, 'kartvy'), [map]).
export const exposeMapForPerf = (map, view) => {
    if (!PERF_RUN || !map) return undefined;
    window.__perfMap = { map, view };
    return () => {
        if (window.__perfMap?.map === map) delete window.__perfMap;
    };
};
